
export const requiredRules = data => ({
	rules: typeof data.value == 'boolean' ? false : !data.value,
	error: data.callback.translate('error_valid_required_fields', {}) ,
	success: 'Good',
});

export const maxLength = maxLength => data => ({
	rules: data.value && String(data.value).length > maxLength,
	error: data.callback.translate('error_valid_max_length', {maxLength}),
	success: 'Good',
});

export const minLength = minLength => data => ({
	rules: data.value && String(data.value).length < minLength,
	error: data.callback.translate('error_valid_min_length', {minLength}),
	success: 'Good',
});

export const samePass = data => ({
	rules: data.value !== data.value,
	error: data.callback.translate('error_text_repeat_new_password', {}),
	success: 'Good',
});

export const emailRegexp = data => ({
	rules: !(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i).test(data.value),
	error: data.callback.translate('error_valid_email_incorrect', {}),
	success: 'Good',
});

export const regExpName = data => ({
	rules: data && !(/^[a-zA-Z\-\'\`\s]+$/).test(data.value),
	error: data.callback.translate('error_valid_regexp_name', {}),
	success: 'Good',
});

export const regexpBirth = data => ({
	rules: !(/^[0-9]{2}-[0-9]{2}-[0-9]{4}$/).test(data.value),
	error: data.callback.translate('error_valid_format_birth'),
	success: 'Good',
});

export const regexpPass = data => ({
	rules: data.value && !(
		/^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9!@#$%^&*();"'_\-.,]{8,30}$/.test(data.value) ||
		/^(?=.*[a-zA-Z])(?=.*[!@#$%^&*();"'_\-.,])[a-zA-Z!@#$%^&*();"'_\-.,]{8,30}$/.test(data.value) ||
		/^(?=.*[0-9])(?=.*[!@#$%^&*();"'_\-.,])[0-9!@#$%^&*();"'_\-.,]{8,30}$/.test(data.value)
	),
	error: data.callback.translate('error_valid_wrong_pass'),
	success: 'Good',
});

export const fieldLength = data => ({
	rules: data.value && (String(data.value).length > 30 || String(data.value).length < 2),
	error: data.callback.translate('error_valid_field_length'),
	success: 'Good',
});

export const phoneMinLength = minLength => data => ({
	rules: data.value && String(data.value).length < minLength,
	error: data.callback.translate('error_valid_phone_min_length', {minLength}),
	success: 'Good',
});

export const phoneMaxLength = maxLength => data => ({
	rules: data.value && String(data.value).length > maxLength,
	error: data.callback.translate('error_valid_phone_max_length', {maxLength}),
	success: 'Good',
});

export const emailMinLength = minLength => data => ({
	rules: data.value && String(data.value).length < minLength,
	error: data.callback.translate('error_valid_email_min_length', {minLength}),
	success: 'Good',
});

export const emailMaxLength = maxLength => data => ({
	rules: data.value && String(data.value).length > maxLength,
	error: data.callback.translate('error_valid_email_max_length', {maxLength}),
	success: 'Good',
});